export const MAX_LENGTH = 200;


export const TYPE = 'text';
